import { render, staticRenderFns } from "./OTPModal.vue?vue&type=template&id=930e63f6"
import script from "./OTPModal.vue?vue&type=script&lang=js"
export * from "./OTPModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports